import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * ai 报警列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	getCarPlateListApi( params={} ) {
		return request({
	    url: baseUrl + '/device/getCameraForCar',
	    method: 'GET',
	    params
	  })
	},
	/**
	 * ai 最新报警
	**/
	getCarPlateNewApi(params={}) {
		return request({
		url: baseUrl + '/device/getWindowForCar',
		method: 'GET',
		params
	  })
	},
	/**
	 * 标记/取消标记
	**/
	setCarinfoMark(id,data){
		return request({
			url: baseUrl + '/device/updateWindowForCar/'+id,
			method:'PUT',
			data
		})
	},
	
}